export const CONFIG = {
    client_name : "stw_schwaebischhall",
    client_display_name : "Stadtwerke Schwäbisch Hall GmbH",
    modal_confirm_button_label : "übernehmen",
    country : 'de',
    base_asset_url : `https://esr.fe-bis.de/de/stw_schwaebischhall/`,
    plz_validation : (plz : string) => plz.length == 5,
    plz_default: "74523",
    foerderung : true,
    development_mode: false,
}
